/* eslint-disable */
import * as Types from '../../graphql/types.generated';

import { gql } from '@apollo/client';
export type AgentCardFragment = { __typename?: 'Agent', name?: string | null, slug?: string | null, licensedYear?: number | null, city?: string | null, county?: string | null, phoneNumber?: string | null, businessCardUrl?: string | null, velocifyId?: number | null, active?: boolean | null, photo?: { __typename?: 'Asset', description?: string | null, url?: string | null, width?: number | null, height?: number | null } | null };

export const AgentCardFragmentDoc = gql`
    fragment AgentCard on Agent {
  name
  slug
  photo {
    description
    url(
      transform: {width: 220, height: 220, resizeStrategy: FILL, resizeFocus: FACE}
    )
    width
    height
  }
  licensedYear
  city
  county
  phoneNumber
  businessCardUrl
  velocifyId
  active
}
    `;